var Loader = {
    load: function () {
        var vendor = require.context('./vendor', true, /\.js$/);
        var components = require.context('./components', true, /\.js$/);
        var pages = require.context('./pages', true, /\.js$/);

        vendor.keys().forEach(function (key) {
            vendor(key);
        });

        components.keys().forEach(function (key) {
            components(key);
        });

        pages.keys().forEach(function (key) {
            pages(key);
        });
    },
};

module.exports = Loader;
